import axios from 'axios'
import { cleanBlankValue } from 'utils/helper'

export const getFinanceAccounts = (params) => {
  return axios.get('/finance/accounts', { params })
}

export const getFinanceAccountsStats = (params) => {
  return axios.get('/finance/accounts/stats', { params })
}

export const getAccountSummary = (id) => {
  return axios.get(`/finance/accounts/${id}/summary`)
}

export const addFinanceAccount = (data) => {
  return axios.post('/finance/accounts', data)
}

export const editFinanceAccount = (data) => {
  return axios.put(`/finance/accounts/${data.id}`, data)
}

export const moveFinanceAccount = (srcId, destId) => {
  return axios.patch(`/finance/accounts/${srcId}/move`, { dest_id: destId })
}

export const activateFinanceAccount = (id) => {
  return axios.patch(`/finance/accounts/${id}/activate`)
}

export const deactivateFinanceAccount = (id) => {
  return axios.patch(`/finance/accounts/${id}/deactivate`)
}

export const archiveFinanceAccount = (id) => {
  return axios.patch(`/finance/accounts/${id}/archive`)
}

export const unarchiveFinanceAccount = (id) => {
  return axios.patch(`/finance/accounts/${id}/unarchive`)
}

export const deleteFinanceAccount = (ids) => {
  return axios.delete('/finance/accounts/massDelete', { data: { id: ids } })
}

export const getSuggestionFinanceAccount = (params, options) => {
  return axios.get('/finance/accounts/suggestionPerPage', { params, ...options })
}

export const getSuggestionFinanceParentAccount = (params) => {
  return axios.get('/finance/accounts/suggestionParentAccountsPerpage', { params })
}

export const getSuggestionFinanceParentAccountWithPagination = (params, config = {}) => {
  return axios.get('/finance/accounts/suggestion', { params, ...config })
}

export const getFinanceAccount = (id, config = {}) => {
  return axios.get(`/finance/accounts/${id}`, config)
}

export const getFinanceBankAccounts = () => {
  return axios.get('/finance/accounts/banks')
}

export const getListFinanceBankAccounts = (params) => {
  return axios.get('/finance/accounts/banks/list', { params })
}

export const uploadImportFinanceAccount = (data) => {
  return axios.postForm('/finance/accounts/uploadImport', data)
}

export const executeImportFinanceAccount = (data) => {
  return axios.post('/finance/accounts/executeImport', data)
}

export const exportAccounts = (params) => {
  params = cleanBlankValue(params)
  return axios.get('/finance/accounts/export', { params, responseType: 'arraybuffer' })
}

export const getFinanceAccountRoles = (id) => {
  return axios.get(`/finance/accounts/${id}/roles`)
}

export const addFinanceAccountRoles = ({ id, data }) => {
  return axios.post(`/finance/accounts/${id}/roles`, data)
}
